export const INITIAL_STATE_CHANGE = "INITIAL_STATE_CHANGE";
export const CHANGE_PASSWORD_OLD = "CHANGE_PASSWORD_OLD";
export const CHANGE_PASSWORD_NEW = "CHANGE_PASSWORD_NEW";
export const CHANGE_PASSWORD_CONFIRM = "CHANGE_PASSWORD_CONFIRM";
export const ERROR_PASSWORD_CONFIRM = "ERROR_PASSWORD_CONFIRM";
export const SHOW_PASSWORD_OLD = "SHOW_PASSWORD_OLD";
export const SHOW_PASSWORD_NEW = "SHOW_PASSWORD_NEW";
export const SHOW_PASSWORD_CONFIRM = "SHOW_PASSWORD_CONFIRM";
export const ONSUBMIT_PASSWORD = "ONSUBMIT_PASSWORD";
export const SUBMIT_NEW_PASSWORD = "SUBMIT_NEW_PASSWORD";